import {
	TYPE_CALL,
	TYPE_VISIT,
	TYPE_SALESMANVISIT,
	TYPE_PROJECT,
} from 'modules/usersApp/reasonMappingsPage/constants';

export const reasonMappingTypes = {
	[TYPE_CALL]: 'ReasonMapping type:call',
	[TYPE_VISIT]: 'ReasonMapping type:visit',
	[TYPE_SALESMANVISIT]: 'ReasonMapping type:salesmanvisit',
	[TYPE_PROJECT]: 'ReasonMapping type:project',
};
